import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import FormMixin from '@/amui/mixins/formMixin';
let AmBizUpload = class AmBizUpload extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    // 图片上传模式下文件
    this.pictureUrl = '';
    this.fileList = [];
    this.imageDialogVisible = false;
    this.imageUrl = '';
  }
  /**
   * 上传按钮尺寸
   */
  get buttonSize() {
    const sizeMap = {
      mini: 'small',
      small: 'medium',
      medium: 'large'
    };
    return (sizeMap === null || sizeMap === void 0 ? void 0 : sizeMap[this.size]) || 'medium';
  }
  /**
   * 卡片上传类型线上内容
   */
  get filters() {
    return this.accept || '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.pps,.pdf,.zip,.rar,.jpg,.jpeg,.gif,.png,.bmp,.ico';
  }
  uploadTypeChange(nval) {
    this.drag = nval === 'drag';
  }
  created() {
    this.drag = this.uploadType === 'drag';
  }
  //初始化完毕事件
  onReady() {
    console.log('-onReady-');
  }
  //选择的文件大小超过后台配置的maxFileSize，回调这个方法，文件不会被加到 files-filter 的 files 里
  fileFiltered(file) {
    console.log('-fileFiltered-', file);
  }
  //用户自定义文件过滤，返回值需要是一个数组，里面保留需要添加到队列的文件
  filesFilter(files) {
    console.log('-filesFilter-', files);
    // 1. 限制上传数量， 完全不可以上传
    // 2. 限制文件大小， 超出大小的过滤
    if (files.length + this.fileList.length > this.limit) {
      this.$message.warning(`最多可上传${this.limit}个文件`);
      return [];
    }
    return files;
  }
  //文件被加入到队列事件
  filesAdded(files) {
    console.log('-filesAdded-', files);
  }
  //某个文件开始上传事件，如果想阻止这个文件的上传，请返回 false，如果这里需要执行异步的操作，可以返回 Promise 对象
  beforeUpload(file) {
    console.log('-onBeforeUpload-', file);
    if (this.uploadType === 'picture' && !'.jpg,.jpeg,.gif,.png,.bmp,.ico'.includes(file.extension)) {
      this.$message.warning(`您选择的图片格式不正确`);
      return false;
    }
    if (file.size / 1024 > this.maxSize) {
      this.$message.warning(`您选择的文件大小已超过允许的大小`);
      return false;
    }
    if (!this.fileList.filter(item => item.uuid === file.uuid).length) {
      this.fileList.push({
        uuid: file.uuid,
        name: file.name,
        url: file.fullUrl,
        type: file.fileType,
        percentage: 0,
        loading: true
      });
    }
  }
  //文件上传速度事件，回调参数（bytes：已上传字节数，time：上传用时，pendings：剩余字节数）
  onNetworkSpeed(a, b, c) {
    console.log('-onNetworkSpeed-', a, b, c);
  }
  //上传进度事件，回调参数（file：上传的文件，progress：已上传比例，event：进度事件参数）
  onProgress(file, progress, event) {
    console.log('-onProgress-', progress);
    const f = this.getFile(file.uuid);
    if (f) {
      f.percentage = progress.toFixed(2) * 100;
    }
  }
  //文件上传成功事件
  onUploaded(file) {
    console.log('-onUploaded-', file);
    const attach = this.fileList.find(item => item.uuid === file.uuid);
    this.$set(attach, 'url', file.fullUrl);
    this.$set(attach, 'status', 'success');
    if (this.uploadType === 'picture') {
      this.pictureUrl = file.fullUrl;
    }
  }
  //队列里面的文件上传结束事件
  onComplete() {
    console.log('-onComplete-');
  }
  //上传出错事件，回调参数（error：错误信息，file：上传的文件）
  onError(error, file) {
    console.log('-onError-', error, file);
    const attach = this.fileList.find(item => item.uuid === file.uuid);
    this.$set(attach, 'url', file.fullUrl);
    this.$set(attach, 'status', 'error');
  }
  getFile(uuid) {
    for (const f of this.fileList) {
      if (f.uuid === uuid) {
        return f;
      }
    }
  }
  //查看文件
  download(url) {
    console.log(url, 111111);
    url && window.open(url, '_blank');
  }
  //删除文件
  deleteFile(file) {
    this.fileList = this.fileList.filter(v => v.uuid !== file.uuid);
  }
  //文件预览
  preview(file) {
    if (file.type === 'image') {
      this.imageUrl = file.url;
      this.imageDialogVisible = true;
    }
  }
  //图片模式下的预览
  previewPic() {
    this.imageUrl = this.pictureUrl;
    this.imageDialogVisible = true;
  }
  //图片模式删除
  deletePic() {
    this.pictureUrl = '';
    this.$set(this, 'fileList', []);
  }
};
AmBizUpload.componentName = 'AmBizUpload';
__decorate([Prop({
  default: 'normal'
})], AmBizUpload.prototype, "uploadType", void 0);
__decorate([Prop({
  default: false
})], AmBizUpload.prototype, "openImageThumbnails", void 0);
__decorate([Prop({
  default: false
})], AmBizUpload.prototype, "isOpen", void 0);
__decorate([Prop()], AmBizUpload.prototype, "source", void 0);
__decorate([Prop({
  required: true
})], AmBizUpload.prototype, "appCode", void 0);
__decorate([Prop({
  required: true
})], AmBizUpload.prototype, "configKey", void 0);
__decorate([Prop({
  required: true
})], AmBizUpload.prototype, "moduleName", void 0);
__decorate([Prop({
  required: true
})], AmBizUpload.prototype, "functionName", void 0);
__decorate([Prop({
  default: false
})], AmBizUpload.prototype, "multipe", void 0);
__decorate([Prop({
  default: true
})], AmBizUpload.prototype, "autoUpload", void 0);
__decorate([Prop({
  default: false
})], AmBizUpload.prototype, "drag", void 0);
__decorate([Prop({
  default: 'upload'
})], AmBizUpload.prototype, "iconClass", void 0);
__decorate([Prop({
  default: true
})], AmBizUpload.prototype, "convert", void 0);
__decorate([Prop()], AmBizUpload.prototype, "limit", void 0);
__decorate([Prop()], AmBizUpload.prototype, "maxSize", void 0);
__decorate([Prop({
  default: false
})], AmBizUpload.prototype, "errorTip", void 0);
__decorate([Prop()], AmBizUpload.prototype, "isV1", void 0);
__decorate([Prop()], AmBizUpload.prototype, "md5", void 0);
__decorate([Prop()], AmBizUpload.prototype, "ticket", void 0);
__decorate([Prop({
  default: false
})], AmBizUpload.prototype, "isLocal", void 0);
__decorate([Prop()], AmBizUpload.prototype, "localGroupId", void 0);
__decorate([Prop({
  default: false
})], AmBizUpload.prototype, "isBizMixDeploy", void 0);
__decorate([Prop({
  type: [Object, Boolean],
  default: true
})], AmBizUpload.prototype, "transcodeOptions", void 0);
__decorate([Prop({
  default: '上传附件'
})], AmBizUpload.prototype, "buttonText", void 0);
__decorate([Prop({
  default: 'primary'
})], AmBizUpload.prototype, "buttonType", void 0);
__decorate([Prop()], AmBizUpload.prototype, "accept", void 0);
__decorate([Prop({
  default: '178px'
})], AmBizUpload.prototype, "pictureWidth", void 0);
__decorate([Prop({
  default: '178px'
})], AmBizUpload.prototype, "pictureHeight", void 0);
__decorate([Watch('uploadType')], AmBizUpload.prototype, "uploadTypeChange", null);
AmBizUpload = __decorate([Component({
  name: 'AmBizUpload'
})], AmBizUpload);
export default AmBizUpload;